import { UploadIcon } from "lucide-react";
import { BalanceIcon } from "@root/assets/icons/balance";
import KcsIcon from "@root/assets/icons/ksc-icon";
import { DrawingIcon } from "@root/assets/icons/drawingicon";
import { ReactComponent as ChecklistIcon } from "@root/assets/icons/checklist-icon (2).svg";
import CheckSquareIcon from "@root/assets/icons/selectFile";
import { ROUTE_NAMES } from "@root/constants";

/**
 * Dropdown items configuration for legal chatbot
 */
export const DROPDOWN_LEGAL_ITEMS = [
  { labelKey: "contact.upload", icon: UploadIcon },
  {
    labelKey: "translate.LegalChatbot",
    icon: BalanceIcon,
    link: ROUTE_NAMES.LEGAL_CHATBOT,
  },
  {
    labelKey: "chatHistory.kcsChatbot",
    icon: KcsIcon,
    link: ROUTE_NAMES.KCS,
  },
];

/**
 * Dropdown items configuration for project document chatbot
 */
export const getProjectDropdownItems = (isDrawingAnalysis: boolean) => [
  {
    labelKey: isDrawingAnalysis ? "contact.upload" : "translate.selectFile",
    icon: isDrawingAnalysis ? UploadIcon : CheckSquareIcon,
  },
  {
    labelKey: "chatHistory.projectDocumentChatbot",
    icon: BalanceIcon,
    link: ROUTE_NAMES.DOCUMENT_INTEGRATION_CHATBOT,
  },
  {
    labelKey: "chatHistory.drawingAnalysisChatbot",
    icon: DrawingIcon,
    link: ROUTE_NAMES.DRAWING_ANALYSIS_DASHBOARD,
  },
  {
    labelKey: "chatHistory.multiDocumentChatbot",
    icon: ChecklistIcon,
    link: ROUTE_NAMES.CHECKLIST,
  },
];
